module.exports = __webpack_public_path__ + "img/australia-genitourinary-diseases-female.f866fb95.png";